const keyboardBase = {
  category: "Keyboards",
  material: "CNC aluminum case, dye-sublimated PBT keycaps",
  size: ["White Flame", "Silent Glacier"],
  attributes: {
    compatibility: "Windows / macOS",
    pollingRate: "1000 Hz",
    keycaps: "Dye-sublimated PBT",
    warranty: "1 year limited warranty",
  },
  tags: ["keyboard", "hot-swap", "rgb", "pbt"],
};

const products = [
  {
    ...keyboardBase,
    id: 1,
    name: "Hush 65 Keyboard — Nightshade",
    collection: "Core",
    price: 119,
    compareAtPrice: 149,
    images: ["/img/product-01.webp", "/img/product-01-detail.webp"],
    description:
      "A compact, tournament-ready 65% board with deep violet accents and a tuned gasket mount for a controlled, satisfying keystroke.",
    colors: ["Nightshade"],
    rating: 4.9,
    reviews: 318,
    inventory: 24,
    badge: "20% OFF",
    featured: true,
    attributes: { ...keyboardBase.attributes, layout: "65% / 68 keys", connection: "USB-C wired" },
  },
  {
    ...keyboardBase,
    id: 2,
    name: "Hush 65 Keyboard — Cobalt Cloud",
    collection: "Core",
    price: 129,
    images: ["/img/product-02.webp", "/img/product-02-detail.webp"],
    description:
      "Warm ivory keycaps meet saturated cobalt modifiers in a clean compact layout built for fast play and everyday creative work.",
    colors: ["Cobalt Cloud"],
    rating: 4.8,
    reviews: 226,
    inventory: 17,
    featured: true,
    newArrival: true,
    attributes: { ...keyboardBase.attributes, layout: "65% / 68 keys", connection: "USB-C wired" },
  },
  {
    ...keyboardBase,
    id: 3,
    name: "Drift 75 Keyboard — Signal Orange",
    collection: "Signal",
    price: 139,
    compareAtPrice: 159,
    images: ["/img/product-03.webp", "/img/product-03-detail.webp"],
    description:
      "A 75% performance board with a programmable control dial, graphic orange accents, and a full function row for power users.",
    colors: ["Signal Orange"],
    rating: 4.9,
    reviews: 194,
    inventory: 31,
    badge: "LIMITED",
    featured: true,
    attributes: { ...keyboardBase.attributes, layout: "75% / 82 keys", connection: "USB-C wired" },
  },
  {
    ...keyboardBase,
    id: 4,
    name: "Drift 96 Keyboard — Field Study",
    collection: "Field",
    price: 169,
    images: ["/img/product-04.webp", "/img/product-04-detail.webp"],
    description:
      "A space-conscious full layout in sage and cream, balancing a number pad with a refined footprint and soft acoustic tuning.",
    colors: ["Sage Cream"],
    rating: 4.7,
    reviews: 88,
    inventory: 8,
    badge: "FEW LEFT",
    attributes: { ...keyboardBase.attributes, layout: "96% / 100 keys", connection: "USB-C wired" },
  },
  {
    ...keyboardBase,
    id: 5,
    name: "Prism 65HE Keyboard — Polar Ice",
    collection: "Prism",
    price: 179,
    images: ["/img/product-05.webp", "/img/product-05-detail.webp"],
    description:
      "Translucent ice-blue keycaps and adjustable magnetic switches deliver rapid-trigger control in an exceptionally crisp 65% build.",
    colors: ["Polar Ice"],
    size: ["Magnetic Glacier"],
    rating: 4.9,
    reviews: 142,
    inventory: 12,
    badge: "RAPID TRIGGER",
    featured: true,
    newArrival: true,
    tags: ["keyboard", "hall-effect", "rapid-trigger", "pbt"],
    attributes: { ...keyboardBase.attributes, layout: "65% / 68 keys", connection: "USB-C wired", pollingRate: "8000 Hz" },
  },
  {
    ...keyboardBase,
    id: 6,
    name: "Drift 75 Keyboard — Redline",
    collection: "Signal",
    price: 132,
    compareAtPrice: 165,
    images: ["/img/product-06.webp", "/img/product-06-detail.webp"],
    description:
      "Graphite and red define a decisive full-function layout with hot-swap sockets and a tactile rotary control.",
    colors: ["Redline"],
    rating: 4.8,
    reviews: 171,
    inventory: 20,
    badge: "20% OFF",
    attributes: { ...keyboardBase.attributes, layout: "75% / 82 keys", connection: "USB-C wired" },
  },
  {
    ...keyboardBase,
    id: 7,
    name: "Drift 75 Keyboard — Tidal Sand",
    collection: "Tidal",
    price: 149,
    images: ["/img/product-07.webp", "/img/product-07-detail.webp"],
    description:
      "A calm sand-and-teal palette wraps a versatile 75% layout tuned for a low, balanced sound signature.",
    colors: ["Tidal Sand"],
    rating: 4.8,
    reviews: 96,
    inventory: 16,
    newArrival: true,
    attributes: { ...keyboardBase.attributes, layout: "75% / 82 keys", connection: "USB-C wired" },
  },
  {
    ...keyboardBase,
    id: 8,
    name: "Drift 75 Keyboard — Ultraviolet",
    collection: "Core",
    price: 145,
    images: ["/img/product-08.webp", "/img/product-08-detail.webp"],
    description:
      "Charcoal alphas, layered lilac accents, and a smooth gasket mount give this 75% board its distinctive creative-studio character.",
    colors: ["Ultraviolet"],
    rating: 4.7,
    reviews: 117,
    inventory: 27,
    attributes: { ...keyboardBase.attributes, layout: "75% / 82 keys", connection: "USB-C wired" },
  },
  {
    ...keyboardBase,
    id: 9,
    name: "Crest 96 Keyboard — Volt Silver",
    collection: "Crest",
    price: 179,
    images: ["/img/product-09.webp", "/img/product-09-detail.webp"],
    description:
      "An efficient 96% aluminum board with electric-lime accents, an integrated dial, and all the keys required for production work.",
    colors: ["Volt Silver"],
    rating: 4.9,
    reviews: 73,
    inventory: 11,
    badge: "PREMIUM",
    attributes: { ...keyboardBase.attributes, layout: "96% / 100 keys", connection: "USB-C wired" },
  },
  {
    ...keyboardBase,
    id: 10,
    name: "Drift 75 Keyboard — Navy Bloom",
    collection: "Bloom",
    price: 149,
    images: ["/img/product-10.webp", "/img/product-10-detail.webp"],
    description:
      "A deep navy chassis with coral accents makes a confident centerpiece without compromising speed, feel, or everyday utility.",
    colors: ["Navy Bloom"],
    rating: 4.8,
    reviews: 108,
    inventory: 14,
    attributes: { ...keyboardBase.attributes, layout: "75% / 82 keys", connection: "USB-C wired" },
  },
  {
    ...keyboardBase,
    id: 11,
    name: "Prism 65 Keyboard — Smoked Glass",
    collection: "Prism",
    price: 159,
    compareAtPrice: 189,
    images: ["/img/product-11.webp", "/img/product-11-detail.webp"],
    description:
      "Smoked translucent keycaps and a compact dark frame expose the mechanical character of this limited hot-swap board.",
    colors: ["Smoked Glass"],
    rating: 4.9,
    reviews: 154,
    inventory: 5,
    badge: "LAST CHANCE",
    attributes: { ...keyboardBase.attributes, layout: "65% / 68 keys", connection: "USB-C wired" },
  },
  {
    ...keyboardBase,
    id: 12,
    name: "Drift 96 Keyboard — Arcade White",
    collection: "Arcade",
    price: 169,
    images: ["/img/product-12.webp", "/img/product-12-detail.webp"],
    description:
      "A graphic white-and-red 96% layout inspired by classic control panels, rebuilt with modern materials and clean acoustics.",
    colors: ["Arcade White"],
    rating: 4.8,
    reviews: 64,
    inventory: 13,
    attributes: { ...keyboardBase.attributes, layout: "96% / 100 keys", connection: "USB-C wired" },
  },
  {
    ...keyboardBase,
    id: 13,
    name: "Crest 75 Keyboard — Bronze Night",
    collection: "Crest",
    price: 180,
    images: ["/img/product-13.webp", "/img/product-13-detail.webp"],
    description:
      "A weighty midnight-blue aluminum board with bronze accents, multilayer dampening, and a deliberately substantial feel.",
    colors: ["Bronze Night"],
    rating: 5,
    reviews: 41,
    inventory: 9,
    badge: "PREMIUM",
    attributes: { ...keyboardBase.attributes, layout: "75% / 82 keys", connection: "USB-C wired" },
  },
  {
    ...keyboardBase,
    id: 14,
    name: "Drift 96 Keyboard — Pink Static",
    collection: "Static",
    price: 165,
    images: ["/img/product-14.webp", "/img/product-14-detail.webp"],
    description:
      "Soft pink and slate grey transform a practical 96% layout into an expressive workspace centerpiece.",
    colors: ["Pink Static"],
    rating: 4.7,
    reviews: 79,
    inventory: 18,
    newArrival: true,
    attributes: { ...keyboardBase.attributes, layout: "96% / 100 keys", connection: "USB-C wired" },
  },
  {
    ...keyboardBase,
    id: 15,
    name: "Drift 75 Keyboard — Hazard",
    collection: "Signal",
    price: 139,
    compareAtPrice: 169,
    images: ["/img/product-15.webp", "/img/product-15-detail.webp"],
    description:
      "High-contrast yellow accents sharpen a graphite 75% board engineered for reliable competitive inputs and fast remapping.",
    colors: ["Hazard"],
    rating: 4.8,
    reviews: 133,
    inventory: 22,
    badge: "18% OFF",
    attributes: { ...keyboardBase.attributes, layout: "75% / 82 keys", connection: "USB-C wired" },
  },
  {
    ...keyboardBase,
    id: 16,
    name: "Drift 96 Keyboard — Glacier",
    collection: "Tidal",
    price: 169,
    images: ["/img/product-16.webp", "/img/product-16-detail.webp"],
    description:
      "An airy white-and-glacier-blue full layout with a dial, dense dampening, and dependable hot-swap flexibility.",
    colors: ["Glacier"],
    rating: 4.9,
    reviews: 102,
    inventory: 19,
    attributes: { ...keyboardBase.attributes, layout: "96% / 100 keys", connection: "USB-C wired" },
  },
  {
    id: 17,
    name: "Glide Wireless Mouse — Ember",
    category: "Mice",
    collection: "Glide",
    price: 89,
    images: ["/img/product-17.webp", "/img/product-17-detail.webp"],
    description: "An ultralight perforated wireless mouse with a precise optical sensor and warm ember detailing.",
    colors: ["Graphite Ember"],
    size: ["Right-handed"],
    material: "Lightweight matte polymer shell",
    rating: 4.8,
    reviews: 211,
    inventory: 32,
    featured: true,
    attributes: { sensor: "26K optical", weight: "58 g", battery: "Up to 70 hours", connection: "2.4 GHz / USB-C" },
    tags: ["mouse", "wireless", "ultralight", "gaming"],
  },
  {
    id: 18,
    name: "Glide Wireless Mouse — Cobalt",
    category: "Mice",
    collection: "Glide",
    price: 89,
    images: ["/img/product-18.webp", "/img/product-18-detail.webp"],
    description: "A crisp ivory wireless mouse with cobalt controls, low-latency performance, and an all-day ergonomic profile.",
    colors: ["Ivory Cobalt"],
    size: ["Right-handed"],
    material: "Lightweight matte polymer shell",
    rating: 4.7,
    reviews: 126,
    inventory: 29,
    newArrival: true,
    attributes: { sensor: "26K optical", weight: "61 g", battery: "Up to 70 hours", connection: "2.4 GHz / USB-C" },
    tags: ["mouse", "wireless", "ergonomic", "gaming"],
  },
  {
    id: 19,
    name: "Glide Wireless Mouse — Ultraviolet",
    category: "Mice",
    collection: "Glide",
    price: 89,
    images: ["/img/product-19.webp", "/img/product-19-detail.webp"],
    description: "A violet performance mouse with a grippy black flank, six programmable inputs, and zero-cable desk freedom.",
    colors: ["Ultraviolet"],
    size: ["Right-handed"],
    material: "Soft-touch polymer shell",
    rating: 4.8,
    reviews: 98,
    inventory: 21,
    attributes: { sensor: "26K optical", weight: "63 g", battery: "Up to 70 hours", connection: "2.4 GHz / USB-C" },
    tags: ["mouse", "wireless", "programmable", "gaming"],
  },
  {
    id: 20,
    name: "Glide Wireless Mouse — Field",
    category: "Mice",
    collection: "Glide",
    price: 84,
    images: ["/img/product-20.webp", "/img/product-20-detail.webp"],
    description: "A calm sage-and-cream mouse designed for balanced control across gaming, editing, and daily work.",
    colors: ["Sage Cream"],
    size: ["Right-handed"],
    material: "Soft-touch polymer shell",
    rating: 4.7,
    reviews: 74,
    inventory: 25,
    attributes: { sensor: "19K optical", weight: "65 g", battery: "Up to 80 hours", connection: "2.4 GHz / USB-C" },
    tags: ["mouse", "wireless", "ergonomic", "creator"],
  },
  {
    id: 21,
    name: "Coil Cable — Signal Weave",
    category: "Accessories",
    collection: "Signal",
    price: 49,
    images: ["/img/product-21.webp", "/img/product-21-detail.webp"],
    description: "A dense navy-and-orange braided USB-C coil cable with a quick-release metal connector.",
    colors: ["Signal Weave"],
    size: ["1.8 m"],
    material: "Braided nylon, anodized alloy",
    rating: 4.8,
    reviews: 62,
    inventory: 44,
    attributes: { connector: "USB-C to USB-A", length: "1.8 m", coil: "15 cm", compatibility: "USB keyboards" },
    tags: ["cable", "usb-c", "desk-setup", "accessory"],
  },
  {
    id: 22,
    name: "Artisan Keycaps — Frozen Core",
    category: "Keycaps",
    collection: "Prism",
    price: 48,
    images: ["/img/product-22.webp", "/img/product-22-detail.webp"],
    description: "Six individually cast translucent resin keycaps with suspended icy forms and MX-compatible stems.",
    colors: ["Frozen Core"],
    size: ["6-key set"],
    material: "Hand-cast clear resin",
    rating: 4.9,
    reviews: 35,
    inventory: 7,
    badge: "HAND CAST",
    attributes: { profile: "Cherry-compatible", stem: "MX cross", count: "6 keycaps", finish: "Polished resin" },
    tags: ["keycaps", "artisan", "resin", "accessory"],
  },
  {
    id: 23,
    name: "Coil Cable — Volt",
    category: "Accessories",
    collection: "Signal",
    price: 49,
    images: ["/img/product-23.webp", "/img/product-23-detail.webp"],
    description: "A vivid volt-green braided coil cable finished with modular silver connectors for a clean desk line.",
    colors: ["Volt"],
    size: ["1.8 m"],
    material: "Braided nylon, anodized alloy",
    rating: 4.7,
    reviews: 49,
    inventory: 38,
    attributes: { connector: "USB-C to USB-A", length: "1.8 m", coil: "15 cm", compatibility: "USB keyboards" },
    tags: ["cable", "usb-c", "desk-setup", "accessory"],
  },
  {
    id: 24,
    name: "Artisan Keycaps — Red Marble",
    category: "Keycaps",
    collection: "Arcade",
    price: 54,
    images: ["/img/product-24.webp", "/img/product-24-detail.webp"],
    description: "A six-piece crimson resin accent set with a white marbled core and a glossy hand-polished finish.",
    colors: ["Red Marble"],
    size: ["6-key set"],
    material: "Hand-cast colored resin",
    rating: 4.8,
    reviews: 28,
    inventory: 10,
    newArrival: true,
    attributes: { profile: "Cherry-compatible", stem: "MX cross", count: "6 keycaps", finish: "Polished resin" },
    tags: ["keycaps", "artisan", "resin", "accessory"],
  },
  {
    id: 25,
    name: "Control Desk Mat XL — Afterburn",
    category: "Mousepads",
    collection: "Signal",
    price: 49,
    images: ["/img/product-25.webp", "/img/product-25-detail.webp"],
    description: "A generous control-surface desk mat with a deep navy and orange abstract composition and stitched edges.",
    colors: ["Afterburn"],
    size: ["900 × 400 mm"],
    material: "Woven control cloth, natural rubber base",
    rating: 4.9,
    reviews: 187,
    inventory: 34,
    featured: true,
    attributes: { dimensions: "900 × 400 × 4 mm", surface: "Micro-woven control", base: "Anti-slip rubber", edge: "Low-profile stitched" },
    tags: ["mousepad", "desk-mat", "control", "setup"],
  },
  {
    id: 26,
    name: "Wrist Rest — Ice Geometry",
    category: "Accessories",
    collection: "Tidal",
    price: 52,
    images: ["/img/product-26.webp", "/img/product-26-detail.webp"],
    description: "A cool-toned geometric wrist rest with a slim aluminum base and softly cushioned top surface.",
    colors: ["Ice Geometry"],
    size: ["65% / 330 mm", "75% / 360 mm"],
    material: "Memory foam, woven fabric, aluminum base",
    rating: 4.7,
    reviews: 56,
    inventory: 23,
    attributes: { width: "330 or 360 mm", height: "18 mm", base: "Anodized aluminum", surface: "Soft woven fabric" },
    tags: ["wrist-rest", "ergonomic", "accessory", "setup"],
  },
];

const productData = products.map((product) => ({
  ...product,
  image: product.images[0],
  Features: Object.entries(product.attributes).map(
    ([key, value]) => `${key.replace(/([A-Z])/g, " $1")}: ${value}`
  ),
}));

export const productCategories = [
  "All",
  "Keyboards",
  "Mice",
  "Mousepads",
  "Keycaps",
  "Accessories",
];

export default productData;
